"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileContainer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDropzone = require("react-dropzone");
var _File = require("./File");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FileContainer = props => {
  const {
    acceptedFileTypes,
    isDisabled,
    isMultipleAllowed,
    maxSizeMB,
    maxFilesAmount,
    minSizeMB,
    onFail,
    onSuccess,
    isFileNameDisplayed = true,
    className,
    onSubmitClick,
    text,
    isUploadButtonDisplayed
  } = props;
  const [addedFiles, setAddedFiles] = (0, _react.useState)([]);
  const handleFail = failedFiles => {
    onFail?.(failedFiles);
  };
  const handleSuccess = succeedFiles => {
    const newFiles = maxFilesAmount ? [...addedFiles, ...succeedFiles].filter((_, index) => index < maxFilesAmount) : [...addedFiles, ...succeedFiles];
    setAddedFiles(newFiles);
    onSuccess?.(newFiles);
  };
  const handleRemoveClick = fileIndex => () => {
    const trimmedFiles = [...addedFiles.filter((el, index) => index !== fileIndex)];
    setAddedFiles(trimmedFiles);
    onSuccess?.(trimmedFiles);
  };
  const {
    getInputProps,
    getRootProps,
    isDragActive,
    open
  } = (0, _reactDropzone.useDropzone)({
    ...(!Array.isArray(acceptedFileTypes) ? {} : {
      accept: acceptedFileTypes
    }),
    maxFiles: maxFilesAmount || 0,
    disabled: isDisabled,
    maxSize: maxSizeMB && maxSizeMB * 1000000,
    minSize: minSizeMB && minSizeMB * 1000000,
    // react-dropzone uses bytes
    multiple: isMultipleAllowed,
    noClick: true,
    noKeyboard: true,
    onDropAccepted: handleSuccess,
    onDropRejected: handleFail
  });
  const fileInputProps = getInputProps();
  const fileRootProps = getRootProps();
  (0, _react.useEffect)(() => {
    isFileNameDisplayed && setAddedFiles([]);
  }, [isFileNameDisplayed]);
  return /*#__PURE__*/_react.default.createElement(_File.File, {
    className: className,
    onSubmitClick: onSubmitClick,
    text: text,
    isUploadButtonDisplayed: isUploadButtonDisplayed,
    addedFiles: addedFiles,
    fileInputProps: fileInputProps,
    fileRootProps: fileRootProps,
    isDisabled: isDisabled,
    isDragActive: isDragActive,
    isMultipleAllowed: isMultipleAllowed,
    onOpenClick: open,
    onRemoveClick: handleRemoveClick
  });
};
exports.FileContainer = FileContainer;
//# sourceMappingURL=FileContainer.js.map